var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	12090: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	88830: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	34288: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	2814: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	43357: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022__browser-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	98272: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	8890: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	32074: {
		fallback: () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_bidi_mjs-_04d91").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/bidi",

	},
	42802: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_cdk_fesm2022__breakpoints-observer-chunk_mjs-_5dc71")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	},
	19570: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_a11y_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",

	},
	86632: {
		fallback: () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_private_mjs-_688b1").then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/private",

	},
	64506: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_forms_fesm2022_forms_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	5690: {
		fallback: () => (Promise.all([__webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_cdk_fesm2022__array-chunk_mjs-node_modules_angular_cdk_fesm2022__css-pix-e68fae1")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 80433))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/coercion",

	},
	25594: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_cdk_fesm2022__passive-listeners-chunk_mjs-node_modules_angular_cdk_fesm2-bf011d1")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/platform",

	},
	7618: {
		fallback: () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_keycodes_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/keycodes",

	},
	7766: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 65129))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers/private",

	},
	4234: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_overlay_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",

	},
	18588: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",

	},
	36634: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_portal_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",

	},
	29204: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_collections_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/collections",

	},
	66790: {
		fallback: () => (Promise.all([__webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_cdk_fesm2022__id-generator-chunk_mjs-node_modules_angular_cdk_fesm2022__-8ecfd31")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 9180))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/accordion",

	},
	95668: {
		fallback: () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_observers_mjs-_b1b11").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers",

	},
	63784: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	37898: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_cdk_fesm2022_text-field_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 69940))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/text-field",

	},
	28458: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_scrolling_mjs"), __webpack_require__.e("default-node_modules_angular_cdk_fesm2022_table_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/cdk/table */ 90198))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/table",

	},
	68274: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_animations_fesm2022_browser_mjs").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	71166: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_forms_angular_forms"), __webpack_require__.e("default-webpack_sharing_consume_default_uobn_core-types_uobn_core-types"), __webpack_require__.e("default-webpack_sharing_consume_default_date-fns_date-fns"), __webpack_require__.e("libs_shared-util_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uobn/shared-util */ 58318))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/shared-util",

	},
	80830: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("libs_core-types_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uobn/core-types */ 53823))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/core-types",

	},
	35320: {
		fallback: () => (__webpack_require__.e("node_modules_uuid_dist_esm-browser_index_js").then(() => (() => (__webpack_require__(/*! uuid */ 37087))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.1.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "uuid",

	},
	87056: {
		fallback: () => (__webpack_require__.e("node_modules_date-fns_index_mjs").then(() => (() => (__webpack_require__(/*! date-fns */ 79561))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.6.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "date-fns",

	},
	27006: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_lodash_lodash"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-webpack_sharing_consume_default_angular-auth-oidc-client_angular-auth-oidc-client"), __webpack_require__.e("default-libs_shared-data-access_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uobn/shared-data-access */ 83221))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/shared-data-access",

	},
	24862: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_lodash_lodash"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_collections_angular_cdk_collections"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-webpack_sharing_consume_default_angular-auth-oidc-client_angular-auth-oidc-client"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_material_form-field_angular_material_form-fie-f37e0d"), __webpack_require__.e("default-webpack_sharing_consume_default_uobn_message-banner_uobn_message-banner"), __webpack_require__.e("default-webpack_sharing_consume_default_uobn_domain-services_uobn_domain-services"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_material_autocomplete_angular_material_autoco-f11868"), __webpack_require__.e("default-node_modules_easepick_datetime_dist_index_esm_js"), __webpack_require__.e("default-webpack_sharing_consume_default_ng-recaptcha-2_ng-recaptcha-2"), __webpack_require__.e("default-libs_ui-primitives_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uobn/ui-primitives */ 51813))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/ui-primitives",

	},
	97250: {
		fallback: () => (__webpack_require__.e("node_modules_lodash_lodash_js").then(() => (() => (__webpack_require__(/*! lodash */ 46227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.17.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lodash",

	},
	4349: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_angular_core"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_router_angular_router"), __webpack_require__.e("default-node_modules_angular-auth-oidc-client_fesm2022_angular-auth-oidc-client_mjs")]).then(() => (() => (__webpack_require__(/*! angular-auth-oidc-client */ 99121))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^19.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "angular-auth-oidc-client",

	},
	24050: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__untracked-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	8604: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_observers_angular_cdk_observers"), __webpack_require__.e("node_modules_angular_material_fesm2022__animation-chunk_mjs-node_modules_angular_material_fes-97a01f1")]).then(() => (() => (__webpack_require__(/*! @angular/material/form-field */ 24950))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/form-field",

	},
	87600: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_observers_angular_cdk_observers"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__animation-chunk_mjs-node_modules_angular_mate-f65f44")]).then(() => (() => (__webpack_require__(/*! @angular/material/input */ 95541))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/input",

	},
	62099: {
		fallback: () => (__webpack_require__.e("default-node_modules_tanstack_angular-table_build_lib_fesm2022_tanstack-angular-table_mjs").then(() => (() => (__webpack_require__(/*! @tanstack/angular-table */ 68002))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "8.21.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@tanstack/angular-table",

	},
	76734: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_lodash_lodash"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-webpack_sharing_consume_default_uobn_shared-data-access_uobn_shared-data-access"), __webpack_require__.e("default-libs_domain-services_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uobn/domain-services */ 87213))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/domain-services",

	},
	13873: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_uobn_core-types_uobn_core-types"), __webpack_require__.e("default-webpack_sharing_consume_default_lodash_lodash"), __webpack_require__.e("default-webpack_sharing_consume_default_uuid_uuid"), __webpack_require__.e("default-webpack_sharing_consume_default_date-fns_date-fns"), __webpack_require__.e("default-libs_components_doc-upload_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uob-strategic-ui/doc-upload */ 7611))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uob-strategic-ui/doc-upload",

	},
	84555: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_material_form-field_angular_material_form-fie-f37e0d"), __webpack_require__.e("default-webpack_sharing_consume_default_tanstack_angular-table_tanstack_angular-table"), __webpack_require__.e("default-libs_components_datagrid_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uobn/datagrid */ 69803))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/datagrid",

	},
	21187: {
		fallback: () => (__webpack_require__.e("default-libs_components_doc-upload-panel_src_index_ts").then(() => (() => (__webpack_require__(/*! @uobn/doc-upload-panel */ 51004))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/doc-upload-panel",

	},
	10103: {
		fallback: () => (__webpack_require__.e("default-libs_components_message-banner_src_index_ts").then(() => (() => (__webpack_require__(/*! @uobn/message-banner */ 52279))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/message-banner",

	},
	79892: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_angular_common"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	22182: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-chunk_mjs-node_modules_angular_materia-ad4604"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-webpack_shari-09ae5e"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__option-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_autocomplete_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/autocomplete */ 79771))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/autocomplete",

	},
	91442: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-chunk_mjs-node_modules_angular_materia-ad4604"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_button_mjs"), __webpack_require__.e("node_modules_angular_material_fesm2022__ripple-module-chunk_mjs-_e3b71")]).then(() => (() => (__webpack_require__(/*! @angular/material/button */ 84175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/button",

	},
	21800: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-chunk_mjs-node_modules_angular_materia-ad4604"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_checkbox_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/checkbox */ 97024))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/checkbox",

	},
	16228: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-chunk_mjs-node_modules_angular_materia-ad4604"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__option-module-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/core */ 74646))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/core",

	},
	43446: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-chunk_mjs-node_modules_angular_materia-ad4604"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-webpack_shari-09ae5e"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_button_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__tooltip-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-module-chunk_mjs-node_modules_angular_-f5e418")]).then(() => (() => (__webpack_require__(/*! @angular/material/datepicker */ 61977))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/datepicker",

	},
	15300: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-chunk_mjs-node_modules_angular_materia-ad4604"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-webpack_shari-09ae5e"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_collections_angular_cdk_collections"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__option-module-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_observers_angular_cdk_observers"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_button_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_select_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__tooltip-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_paginator_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/paginator */ 24624))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/paginator",

	},
	7250: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-chunk_mjs-node_modules_angular_materia-ad4604"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__form-field-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-webpack_shari-09ae5e"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_collections_angular_cdk_collections"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__option-module-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_observers_angular_cdk_observers"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_select_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/select */ 25175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/select",

	},
	13386: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_table_angular_cdk_table"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_sort_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/sort */ 22047))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/sort",

	},
	27820: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_collections_angular_cdk_collections"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_table_angular_cdk_table"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_table_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/table */ 77697))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/table",

	},
	92107: {
		fallback: () => (__webpack_require__.e("default-node_modules_ng-recaptcha-2_fesm2022_ng-recaptcha-2_mjs").then(() => (() => (__webpack_require__(/*! ng-recaptcha-2 */ 66341))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-recaptcha-2",

	},
	29692: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_badge_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/badge */ 16256))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/badge",

	},
	9576: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_icon_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/icon */ 93840))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/icon",

	},
	54221: {
		fallback: () => (__webpack_require__.e("node_modules_intl-tel-input_index_js").then(() => (() => (__webpack_require__(/*! intl-tel-input */ 18695))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "intl-tel-input",

	},
	78515: {
		fallback: () => (__webpack_require__.e("default-libs_components_beneficiary_src_index_ts").then(() => (() => (__webpack_require__(/*! @uob-strategic-ui/beneficiary */ 18022))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uob-strategic-ui/beneficiary",

	},
	71831: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_uobn_message-banner_uobn_message-banner"), __webpack_require__.e("default-libs_components_grid-row-list_src_index_ts")]).then(() => (() => (__webpack_require__(/*! @uobn/grid-row-list */ 45419))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/grid-row-list",

	},
	21254: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022__browser-chunk_mjs"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations */ 43835))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",

	},
	64864: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("default-node_modules_easepick_datetime_dist_index_esm_js"), __webpack_require__.e("node_modules_gsp-design-system_elements_src_index_js")]).then(() => (() => (__webpack_require__(/*! @gsp-design-system/elements */ 44503))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.1.161",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@gsp-design-system/elements",

	},
	97340: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @uobn/app-config */ 32056))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/app-config",

	},
	54078: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_card_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/card */ 53777))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/card",

	},
	40200: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_collections_angular_cdk_collections"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_expansion_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/expansion */ 19322))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/expansion",

	},
	37988: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform"), __webpack_require__.e("default-node_modules_angular_material_fesm2022__ripple-chunk_mjs-node_modules_angular_materia-ad4604"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-webpack_shari-09ae5e"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_menu_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/menu */ 31034))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/menu",

	},
	26084: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout"), __webpack_require__.e("default-node_modules_angular_material_fesm2022_progress-spinner_mjs")]).then(() => (() => (__webpack_require__(/*! @angular/material/progress-spinner */ 41134))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/progress-spinner",

	},
	49289: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @uob-strategic-ui/dynamic-text */ 65640))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uob-strategic-ui/dynamic-text",

	},
	25413: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(/*! @uob-strategic-ui/label-value */ 19033))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uob-strategic-ui/label-value",

	},
	65737: {
		fallback: () => (__webpack_require__.e("default-libs_components_doc-element_src_index_ts").then(() => (() => (__webpack_require__(/*! @uobn/doc-element */ 49936))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/doc-element",

	},
	97155: {
		fallback: () => (__webpack_require__.e("default-libs_components_passcode_src_index_ts").then(() => (() => (__webpack_require__(/*! @uobn/passcode */ 44299))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@uobn/passcode",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		12090
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		88830
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		34288
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		2814
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		43357
	],
	"default-node_modules_angular_core_fesm2022__resource-chunk_mjs": [
		98272,
		8890
	],
	"default-webpack_sharing_consume_default_angular_cdk_bidi_angular_cdk_bidi": [
		32074
	],
	"default-webpack_sharing_consume_default_angular_cdk_layout_angular_cdk_layout": [
		42802
	],
	"default-webpack_sharing_consume_default_angular_cdk_a11y_angular_cdk_a11y": [
		19570
	],
	"default-webpack_sharing_consume_default_angular_cdk_private_angular_cdk_private": [
		86632
	],
	"default-webpack_sharing_consume_default_angular_forms_angular_forms": [
		64506
	],
	"default-webpack_sharing_consume_default_angular_cdk_coercion_angular_cdk_coercion": [
		5690
	],
	"default-webpack_sharing_consume_default_angular_cdk_platform_angular_cdk_platform": [
		25594
	],
	"default-webpack_sharing_consume_default_angular_cdk_keycodes_angular_cdk_keycodes": [
		7618
	],
	"default-node_modules_angular_material_fesm2022__form-field-chunk_mjs": [
		7766
	],
	"default-webpack_sharing_consume_default_angular_cdk_overlay_angular_cdk_overlay-webpack_shari-09ae5e": [
		4234,
		18588
	],
	"default-webpack_sharing_consume_default_angular_cdk_portal_angular_cdk_portal": [
		36634
	],
	"default-webpack_sharing_consume_default_angular_cdk_collections_angular_cdk_collections": [
		29204
	],
	"default-node_modules_angular_material_fesm2022_expansion_mjs": [
		66790
	],
	"default-webpack_sharing_consume_default_angular_cdk_observers_angular_cdk_observers": [
		95668
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		63784
	],
	"default-node_modules_angular_material_fesm2022__animation-chunk_mjs-node_modules_angular_mate-f65f44": [
		37898
	],
	"default-webpack_sharing_consume_default_angular_cdk_table_angular_cdk_table": [
		28458
	],
	"default-webpack_sharing_consume_default_angular_animations_browser_angular_animations_browser": [
		68274
	],
	"default-webpack_sharing_consume_default_uobn_shared-util_uobn_shared-util": [
		71166
	],
	"default-webpack_sharing_consume_default_uobn_core-types_uobn_core-types": [
		80830
	],
	"default-webpack_sharing_consume_default_uuid_uuid": [
		35320
	],
	"default-webpack_sharing_consume_default_date-fns_date-fns": [
		87056
	],
	"default-webpack_sharing_consume_default_uobn_shared-data-access_uobn_shared-data-access": [
		27006
	],
	"default-webpack_sharing_consume_default_uobn_ui-primitives_uobn_ui-primitives": [
		24862
	],
	"default-webpack_sharing_consume_default_lodash_lodash": [
		97250
	],
	"default-webpack_sharing_consume_default_angular-auth-oidc-client_angular-auth-oidc-client": [
		4349
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		24050
	],
	"default-webpack_sharing_consume_default_angular_material_form-field_angular_material_form-fie-f37e0d": [
		8604,
		87600
	],
	"default-webpack_sharing_consume_default_tanstack_angular-table_tanstack_angular-table": [
		62099
	],
	"default-webpack_sharing_consume_default_uobn_domain-services_uobn_domain-services": [
		76734
	],
	"default-webpack_sharing_consume_default_uob-strategic-ui_doc-upload_uob-strategic-ui_doc-upload": [
		13873
	],
	"default-webpack_sharing_consume_default_uobn_datagrid_uobn_datagrid-webpack_sharing_consume_d-7e777e": [
		84555,
		21187
	],
	"default-webpack_sharing_consume_default_uobn_message-banner_uobn_message-banner": [
		10103
	],
	"default-webpack_sharing_consume_default_angular_router_angular_router": [
		79892
	],
	"default-webpack_sharing_consume_default_angular_material_autocomplete_angular_material_autoco-f11868": [
		22182,
		91442,
		21800,
		16228,
		43446,
		15300,
		7250,
		13386,
		27820
	],
	"default-webpack_sharing_consume_default_ng-recaptcha-2_ng-recaptcha-2": [
		92107
	],
	"default-libs_ui-primitives_src_index_ts": [
		29692,
		9576,
		54221
	],
	"default-libs_tenant-journeys_src_form-player-api_service_ts": [
		78515,
		71831
	],
	"apps_uob-form-ui_src_bootstrap_ts": [
		21254,
		64864,
		97340
	],
	"default-apps_uob-form-ui_src_app_remote-entry_entry_routes_ts": [
		54078,
		40200,
		37988,
		26084,
		49289,
		25413,
		65737,
		97155
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}